
type Props = {};

const PageNotFound = (props: Props) => {

  return (
    <div className="rounded-md border-2 mt-1 h-screen">
      <div className="flex w-full  flex-col ">
        <h2 className="text-3xl font-extrabold mb-3 text-center">
          Page not available.
        </h2>
      </div>
    </div>
  );
};

export default PageNotFound;
